import {LanguageShortcut} from './enum';

export class Language {
    public name: string;
    public shortcut: LanguageShortcut;

    constructor(init?: Partial<Language>) {
        Object.assign(this, init);
    }
}
